import { ref } from "vue";
import type { CreateCognitoUserMutation, UpdateCognitoUserMutation, UpdateCognitoUserPasswordMutation } from "@/generated/graphql";

/**
 * オペレータ登録 UI状態管理を扱う composable。
 * ダイアログ表示・ローディング・モードフラグを一元管理する。
 */
export const useOperatorRegisterUiState = () => {
  //エラーダイアログ
  const errdialog = ref<boolean>(false);
  //エラーメッセージ
  const errMessage = ref<string>("");

  // 更新モードフラグ
  const updateMode = ref<boolean>(false);

  //Loading
  const overlay = ref<boolean>(false);

  //ダイアログ初期化
  const displayConfirmDialog = ref<boolean>(false);
  const displayCompletedDialog = ref<boolean>(false);

  // オペレータ作成 レスポンス
  const createCognitoUserMutation = ref<
    CreateCognitoUserMutation | null | undefined
  >(null);

  // オペレータ更新 レスポンス
  const updateCognitoUserMutation = ref<
    UpdateCognitoUserMutation | null | undefined
  >(null);

  // オペレータパスワード更新 レスポンス
  const updateCognitoUserPasswordMutation = ref<
    UpdateCognitoUserPasswordMutation | null | undefined
  >(null);

  return {
    errdialog,
    errMessage,
    updateMode,
    overlay,
    displayConfirmDialog,
    displayCompletedDialog,
    createCognitoUserMutation,
    updateCognitoUserMutation,
    updateCognitoUserPasswordMutation,
  };
};
